const { BASE_URL } = require("./client");

const GET_REVENUE_DATA = BASE_URL + "/api/revenueform";
const POST_REVENUE_DATA = BASE_URL + "/api/revenueform";
const UPDATE_REVENUE_DATA = BASE_URL + "/api/revenueform";
const DELETE_REVENUE_DATA = BASE_URL + "/api/revenueform";

module.exports = {
  GET_REVENUE_DATA,
  POST_REVENUE_DATA,
  UPDATE_REVENUE_DATA,
  DELETE_REVENUE_DATA,
};
